import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'
import { createPromise } from '@wix/thunderbolt-commons'
import { IViewerBatchingManager, ViewerBatchingManagerSymbol } from 'ds-feature-model-updates-invoker'
import { CarmiInstance, ILogger, LoggerSymbol } from '@wix/thunderbolt-symbols'

export const ViewerManagerActionApi = withDependencies(
	[ViewerBatchingManagerSymbol, CarmiInstance, LoggerSymbol],
	(
		viewerBatchingManager: IViewerBatchingManager,
		dsCarmi: DSCarmi,
		logger: ILogger
	): IViewerManagerImplementor<'actions'> => {
		return {
			actions: {
				runInBatch: (callback: Function) => {
					try {
						dsCarmi.$runInBatch(() => {
							const { promise, resolver } = createPromise()
							viewerBatchingManager.addRenderBlockingTask(promise)
							callback()
							logger.flushBreadcrumbBatch()
							resolver()
						})
					} catch (error) {
						logger.captureError(error, {
							tags: { feature: 'ds-feature-viewer-manager-action-api', dsCarmiError: true },
						})
						throw error
					}
				},
			},
		}
	}
)
